<template>
	<v-app>
		<v-app-bar
			app
			elevation="0"
			dense
			height="48"
			center
			class="header-review"
		>
			<v-spacer />
			<!-- history back 버튼이 우측 X버튼 기능으로 바뀜 -->
			<!-- <v-btn
        v-if="isMobile()"
        text
        min-width="44"
        height="44"
        class="btn-back px-0"
        @click="historyBack()"
      >
      </v-btn>
      <span
        v-if="!isMobile()"
        id="pc-spacer"
      > -->

			<v-btn
				color="#191923"
				min-width="48"
				height="48"
				class="px-0 review-title"
				text
			>
				{{ title() }}
			</v-btn>
			<!-- 타이틀 대신 이미지 롤링 갯수 (스와이퍼 처리)-->

			<v-btn
				@click="historyBack()"
				min-width="48"
				width="48"
				height="48"
				class="btn-close px-0"
				text
				absolute
			>
			</v-btn>

			<!-- history back 버튼이 우측 X버튼 기능으로 바뀜 -->
			<!-- <v-btn
        v-if="closeBtnCheck()"
        @click="windowClose()"
        min-width="44"
        width="44"
        height="44"
        class="btn-close px-0"
        text 
      >
      </v-btn> -->
		</v-app-bar>
		<div><!--테스트--></div>
		<v-main>
			<router-view />
		</v-main>
	</v-app>
</template>

<script>
import store from "@/store";

export default {
	name: "App",
	data() {
		return {
			pathHistory: "",
		};
	},
	methods: {
		title() {
			return store.state.title;
		},
		historyBack() {
			if (this.$route.path.includes("report")) {
				const userConfirmed = confirm(
					"신고를 그만두시겠습니까?"
				);

				if (userConfirmed) {
					if (store.state.firstPath == this.$route.path) {
						if ("Y" == store.state.appYn) {
							location.href = "toapp://close";
						} else {
							window.close();
						}
						return;
					} else {
						this.pathHistory = this.$route.path;
					}
					this.$router.go(-1);
				} else {
					//아무 작업도 하지않음
					return;
				}
			}

			if (store.state.firstPath == this.$route.path) {
				if ("Y" == store.state.appYn) {
					location.href = "toapp://close";
				} else {
					window.close();
				}
				return;
			} else {
				this.pathHistory = this.$route.path;
			}
			this.$router.go(-1);
		},
		closeBtnCheck() {
			return !this.$route.path.startsWith("/detail/");
		},
		windowClose() {
			if ("Y" == store.state.appYn) {
				location.href = "toapp://close";
			} else {
				window.close();
			}
		},
		isMobile() {
			if (
				/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
					navigator.userAgent
				)
			) {
				return true;
			} else return false;
		},
	},
	updated() {
		store.commit("SET_FIRSTPATH", this.$route.path);
	},
	mounted() {
		store.commit("SET_FIRSTPATH", this.$route.path);
	},
};
</script>

<style lang="scss">
.review-title {
	width: 100%;
}
.review-title span {
	font-family: -apple-system, BlinkMacSystemFont, "Roboto", "Segoe UI",
		"Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
		"Helvetica Neue", helvetica, sans-serif;
	font-weight: 600;
	font-size: 16px;
	letter-spacing: -0.4px;
}
.header-review {
	position: relative;
	background: #fff !important;
	border-bottom: 0 !important;
	.theme--light.v-btn:hover::before {
		opacity: 0;
	}
}
.btn-back {
	width: 48px;
	height: 48px;
	background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24'%3E%3Cdefs%3E%3Cfilter color-interpolation-filters='auto' id='a'%3E%3CfeColorMatrix in='SourceGraphic' values='0 0 0 0 0.098039 0 0 0 0 0.098039 0 0 0 0 0.137255 0 0 0 0.880000 0'/%3E%3C/filter%3E%3C/defs%3E%3Cg transform='translate(-11 -10)' filter='url(%23a)' fill='none' fill-rule='evenodd'%3E%3Cpath d='m19.414 22 7.293-7.293a1 1 0 1 0-1.414-1.414l-7.996 7.996-.002.002-.002.002a1 1 0 0 0 0 1.414l8 8a1 1 0 1 0 1.414-1.414L19.414 22z' fill='%231B1B23'/%3E%3C/g%3E%3C/svg%3E");
	background-repeat: no-repeat;
	background-position: center;
	margin-left: 3px;
}
.btn-close {
	position: absolute;
	top: 0;
	right: 0;
	display: block;
	width: 48px;
	height: 48px;
	background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24'%3E%3Cdefs%3E%3Cfilter color-interpolation-filters='auto' id='a'%3E%3CfeColorMatrix in='SourceGraphic' values='0 0 0 0 0.098149 0 0 0 0 0.098149 0 0 0 0 0.138477 0 0 0 1.000000 0'/%3E%3C/filter%3E%3C/defs%3E%3Cg transform='translate(-14 -10)' filter='url(%23a)' fill='none' fill-rule='evenodd'%3E%3Cpath d='m27.06 22 4.721-4.72a.753.753 0 0 0 0-1.062.752.752 0 0 0-1.06 0L26 20.94l-4.721-4.72a.752.752 0 0 0-1.06 0 .753.753 0 0 0 0 1.06l4.72 4.72-4.72 4.721a.753.753 0 0 0 0 1.061.752.752 0 0 0 1.06 0L26 23.061l4.72 4.72a.752.752 0 0 0 1.061 0 .753.753 0 0 0 0-1.06L27.061 22z' fill='%231B1B23'/%3E%3C/g%3E%3C/svg%3E");
	background-repeat: no-repeat;
	background-position: center;
}
#pc-spacer {
	min-width: 16px;
	height: 48px;
}
</style> 
